<div mat-dialog-title>
  <span>{{ data.title }}</span>
</div>
<div mat-dialog-content>
  <span i18n class="whitespace-pre-line">{{ data.message }}</span>
</div>
<div mat-dialog-actions>
  <button i18n [mat-dialog-close]="true" mat-raised-button>Прочитано</button>
</div>
